{#if popup && show}
<div class="section backdrop"
  transition:fade={{duration: 500}}
  on:click={closeModal}
  >
  <div class="column is-one-third-desktop has-background-white modal-container" on:click|stopPropagation={() => {}}>
    <h2 class="headline is-size-3 mb-4">{popup.title}</h2>
    <div class="content">{@html popup.text}</div>
    <div class="has-text-right"><a on:click|stopPropagation={closeModal} class="button is-secondary mt-1">Schließen</a></div>
  </div>
</div>
{/if}

<script>
import { onDestroy, onMount } from "svelte";
import { fade } from 'svelte/transition';
import { progressSvc } from "../services";
import { currentPopup, userProgress } from "../stores";
let popup, show, userProgressData;
const bodyClass = 'begolf-has-popup';

const closeModal = (persist = true) => {
  document.body.classList.remove(bodyClass);
  show = false;
  if (persist && popup) {
    if(!userProgressData) {
      userProgressData = {};
    }
    if(!userProgressData.closedPopups) {
      userProgressData.closedPopups = {};
    }
    userProgressData.closedPopups[popup.routeKey] = true;
    progressSvc.setUserProgress(userProgressData);
  }
};
const openModal = () => {
  document.body.classList.add(bodyClass);
  show = true;
};

onMount(() => {
  currentPopup.subscribe(p => {
    popup = p;
    /**
     * popup can be:
     * - undefined > do not show
     * - defined, show property is defined > boolean
     * - defined, show is undefined > show = true
    */
    if (!p || !p.show || userProgressData?.closedPopups && userProgressData?.closedPopups[popup.routeKey]) {
      closeModal(false);
    } else {
      openModal();
    }
  });

  userProgress.subscribe(up => {
    if (Object.keys(up).length) {
      userProgressData = up;
    }
  });
});
onDestroy(closeModal);
</script>
<style type="text/scss">
.headline {
  padding-bottom: 5px;
  border-bottom: 1px solid rgb(74, 74, 74);
  margin-bottom: 25px;
  padding-right: 30px;
  display: inline-block;
}
.backdrop {
  background: rgba(0,0,0, 0.3);
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 10;
  padding-top: 20vh;
}
.modal-container {
  position: relative;
  border-radius: 10px;
  border: 1px solid rgb(74, 74, 74);
  margin: 0 auto;
  padding: 1.25rem;
}

:global(body.begolf-has-popup .section:not(.backdrop)) {
  filter: blur(2px);
}
</style>